<template>
    <div class="container-fluid">
        <!-- 购物车总览卡片 -->
        <!-- row ：Bootstrap网格系统的行容器 mb-4 ：margin-bottom: 4单位 -->
        <div class="row mb-4">
            <!-- col-12 ：占满12列 占满一整行 -->
            <div class="col-12">
                <!-- 使用card: 提供阴影、边框、圆角 -->
                <div class="card bg-light">
                    <div class="card-body">
                        <div class="row text-center">
                            <!-- col-md-3 中等屏幕以上占3列（25%宽度） -->
                            <div class="col-md-3 mb-2">
                                <h5 class="text-primary mb-1">{{ totalItems }}</h5>
                                <!-- text-m 灰色次要文本 -->
                                <small class="text-muted">商品总数</small>
                            </div>
                            <div class="col-md-3 mb-2">
                                <h5 class="text-success mb-1">{{ selectedItems }}</h5>
                                <small class="text-muted">已选商品</small>
                            </div>
                            <div class="col-md-3 mb-2">
                                <h5 class="text-warning mb-1">¥{{ totalPrice.toFixed(2) }}</h5>
                                <small class="text-muted">总金额</small>
                            </div>
                            <div class="col-md-3 mb-2">
                                <h5 class="text-info mb-1">{{ currentCategory }}</h5>
                                <small class="text-muted">当前分类</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分区选择标签页 -->
        <!-- nav-pills  胶囊样式的导航  nav-fill: 导航项占满父容器宽度 子项会自动平均分配或者填充宽度 -->
        <ul class="nav nav-pills nav-fill mb-4" id="categoryTab" role="tablist">
            <li class="nav-item" role="presentation">
                <!-- data-bs-toggle="pill" ：Bootstrap 5的标签页切换触发器 
                data-bs-target="#fruits" ：指向对应内容区域 
                aria-controls ：无障碍属性，关联控制的内容区域 -->
                <button class="nav-link active" id="fruits-tab" data-bs-toggle="pill" data-bs-target="#fruits"
                    type="button" role="tab" aria-controls="fruits" aria-selected="true" @click="activeTab = 'fruits'">
                    <!-- bi bi-apple 苹果图标 -->
                    <i class="bi bi-apple"></i> 新鲜水果
                    <!-- badge 徽章 显示数量 
                     ms-1 ：margin-start: 左外边距 1单位  徽章与图标之间的间距
                     -->
                    <span class="badge bg-danger ms-3">{{ categories.fruits.length }}</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="clothing-tab" data-bs-toggle="pill" data-bs-target="#clothing"
                    type="button" role="tab" aria-controls="clothing" aria-selected="false"
                    @click="activeTab = 'clothing'">
                    <!-- bi bi-star 星星图标 -->
                    <i class="bi bi-star"></i> 时尚穿搭
                    <span class="badge bg-primary ms-3">{{ categories.clothing.length }}</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" id="wine-tab" data-bs-toggle="pill" data-bs-target="#wine" type="button"
                    role="tab" aria-controls="wine" aria-selected="false" @click="activeTab = 'wine'">
                    <!-- bi bi-cup-straw 杯状图标 -->
                    <i class="bi bi-cup-straw"></i> 精选美酒
                    <span class="badge bg-warning ms-3">{{ categories.wine.length }}</span>
                </button>
            </li>
        </ul>

        <!-- 标签页内容 -->
        <!-- tab-content ：Bootstrap标签页内容容器 -->
        <div class="tab-content">
            <!-- 水果分区 -->
            <!-- tab-pane ：Bootstrap标签页内容面板
             fade ：淡入淡出的动画效果
             show ：显示当前标签页内容
             active ：当前标签页内容默认显示
             aria-labelledby ：关联对应的标签按钮id
              -->
            <div class="tab-pane fade show active" id="fruits" role="tabpanel" aria-labelledby="fruits-tab">
                <!-- - d-flex ：启用Flexbox布局
                - justify-content-between ：主轴子项两端对齐
                - align-items-center ：侧轴垂直居中对齐
                - text-success ：绿色文本
                - mb-0 ：移除底部外边距 -->
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h3 class="text-success mb-0">
                        <i class="bi bi-basket"></i> 新鲜水果专区
                    </h3>
                    <button class="btn btn-outline-success btn-sm" @click="selectAll('fruits')">
                        <i class="bi bi-check-all"></i> 全选
                    </button>
                </div>
                <product-table :products="categories.fruits" @update-products="(p) => updateProducts('fruits', p)" />
            </div>

            <!-- 穿搭分区 -->
            <div class="tab-pane fade" id="clothing" role="tabpanel" aria-labelledby="clothing-tab">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h3 class="text-primary mb-0">
                        <i class="bi bi-bag-check"></i> 时尚穿搭专区
                    </h3>
                    <button class="btn btn-outline-primary btn-sm" @click="selectAll('clothing')">
                        <i class="bi bi-check-all"></i> 全选
                    </button>
                </div>
                <product-table :products="categories.clothing"
                    @update-products="(p) => updateProducts('clothing', p)" />
            </div>

            <!-- 酒分区 -->
            <div class="tab-pane fade" id="wine" role="tabpanel" aria-labelledby="wine-tab">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h3 class="text-warning mb-0">
                        <i class="bi bi-cup-hot"></i> 精选美酒专区
                    </h3>
                    <button class="btn btn-outline-warning btn-sm" @click="selectAll('wine')">
                        <i class="bi bi-check-all"></i> 全选
                    </button>
                </div>
                <product-table :products="categories.wine" @update-products="(p) => updateProducts('wine', p)" />
            </div>
        </div>

        <!-- 结算区域 -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="card border-success">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-md-8">
                                <h5 class="card-title">
                                    <i class="bi bi-credit-card"></i> 结算中心
                                </h5>
                                <p class="card-text">
                                    已选择 <strong>{{ selectedItems }}</strong> 件商品，
                                    总计 <strong class="text-danger">¥{{ totalPrice.toFixed(2) }}</strong>
                                </p>
                            </div>
                            <div class="col-md-4 text-md-end">
                                <button class="btn btn-success btn-lg" @click="checkout"
                                    :disabled="selectedItems === 0">
                                    <i class="bi bi-cart-check"></i> 立即结算
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProductTable from './ProductTable.vue';

export default {
    name: 'ShopMain',
    components: {
        ProductTable
    },
    data() {
        return {
            activeTab: 'fruits', // 默认激活的水果标签
            categories: {
                fruits: [
                    { id: 1, name: '苹果', imgUrl: require('@/assets/水果/苹果.png'), price: 10, count: 0, checked: false },
                    { id: 2, name: '西瓜', imgUrl: require('@/assets/水果/西瓜.png'), price: 15, count: 0, checked: false },
                    { id: 3, name: '牛油果', imgUrl: require('@/assets/水果/牛油果.png'), price: 12, count: 0, checked: false },
                    { id: 4, name: '木瓜', imgUrl: require('@/assets/水果/木瓜.png'), price: 8, count: 0, checked: false },
                    { id: 5, name: '柠檬', imgUrl: require('@/assets/水果/柠檬.png'), price: 6, count: 0, checked: false },
                    { id: 6, name: '猕猴桃', imgUrl: require('@/assets/水果/猕猴桃.png'), price: 13, count: 0, checked: false },
                    { id: 7, name: '脐橙', imgUrl: require('@/assets/水果/脐橙.png'), price: 9, count: 0, checked: false },
                    { id: 8, name: '草莓', imgUrl: require('@/assets/水果/草莓.png'), price: 18, count: 0, checked: false },
                    { id: 9, name: '菠萝', imgUrl: require('@/assets/水果/菠萝.png'), price: 11, count: 0, checked: false },
                    { id: 10, name: '香蕉', imgUrl: require('@/assets/水果/香蕉.png'), price: 7, count: 0, checked: false }
                ],
                clothing: [
                    { id: 101, name: '牛仔外套', imgUrl: require('@/assets/穿搭/牛仔外套.png'), price: 199, count: 0, checked: false },
                    { id: 102, name: '红色礼裙', imgUrl: require('@/assets/穿搭/红色礼裙.png'), price: 299, count: 0, checked: false },
                    { id: 103, name: '绿色工装裤', imgUrl: require('@/assets/穿搭/绿色工装裤.png'), price: 159, count: 0, checked: false },
                    { id: 104, name: '羊毛衫', imgUrl: require('@/assets/穿搭/羊毛衫.png'), price: 259, count: 0, checked: false },
                    { id: 105, name: '黑色T恤', imgUrl: require('@/assets/穿搭/黑色T恤.png'), price: 89, count: 0, checked: false }
                ],
                wine: [
                    { id: 201, name: '威士忌', imgUrl: require('@/assets/酒/威士忌.png'), price: 399, count: 0, checked: false },
                    { id: 202, name: '白葡萄酒', imgUrl: require('@/assets/酒/白葡萄酒.png'), price: 199, count: 0, checked: false },
                    { id: 203, name: '红酒', imgUrl: require('@/assets/酒/红酒.png'), price: 299, count: 0, checked: false }
                ]
            }
        }
    },
    // 计算属性
    computed: {
        // 选中且已购买(数量大于0)商品总数量
        totalItems() {
            let total = 0;
            Object.values(this.categories).forEach(category => {
                total += category.reduce((sum, item) => sum + item.count, 0);
            });
            return total;
        },
        selectedItems() {
            let total = 0;
            Object.values(this.categories).forEach(category => {
                total += category.reduce((sum, item) => sum + (item.checked ? item.count : 0), 0);
            });
            return total;
        },
        totalPrice() {
            let total = 0;
            Object.values(this.categories).forEach(category => {
                total += category.reduce((sum, item) => sum + (item.checked ? item.price * item.count : 0), 0);
            });
            return total;
        },
        currentCategory() {
            const categoryMap = {
                'fruits': '新鲜水果',
                'clothing': '时尚穿搭',
                'wine': '精选美酒'
            };
            return categoryMap[this.activeTab] || '全部';
        }
    },
    methods: {
        updateProducts(category, updatedProducts) {
            this.categories[category] = updatedProducts;
            this.$forceUpdate();
        },
        selectAll(category) {
            const allChecked = this.categories[category].every(item => item.checked);
            this.categories[category].forEach(item => {
                item.checked = !allChecked;
            });
            this.$forceUpdate();
        },
        checkout() {
            if (this.selectedItems === 0) {
                alert('请先选择商品！');
                return;
            }

            const selectedProducts = [];
            Object.values(this.categories).forEach(category => {
                category.forEach(item => {
                    if (item.checked && item.count > 0) {
                        selectedProducts.push(item);
                    }
                });
            });

            const orderDetails = selectedProducts.map(item =>
                `${item.name} × ${item.count} = ¥${(item.price * item.count).toFixed(2)}`
            ).join('\n');

            alert(`订单确认：\n\n${orderDetails}\n\n总计：¥${this.totalPrice.toFixed(2)}\n\n感谢您的购买！`);
        }
    }
}
</script>

<style scoped>
.nav-pills .nav-link {
    color: #6c757d;
    font-weight: 500;
    padding: 12px 20px;
    margin: 0 5px;
    border-radius: 25px;
    transition: all 0.3s ease;
}

.nav-pills .nav-link:hover {
    background-color: #f8f9fa;
    color: #495057;
}

.nav-pills .nav-link.active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.nav-pills .nav-link.active:nth-child(1) {
    background: linear-gradient(135deg, #56ab2f 0%, #a8e6cf 100%);
}

.nav-pills .nav-link.active:nth-child(2) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.nav-pills .nav-link.active:nth-child(3) {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.card {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border: none;
}

.btn-group-sm>.btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

@media (max-width: 768px) {
    .nav-pills {
        flex-direction: column;
    }

    .nav-pills .nav-link {
        margin: 2px 0;
    }
}
</style>